import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Name this Print Job',
      placeholder: 'A5 flyer - special promotion',
    },
    format: {
      label: 'Product Type',
      placeholder: 'Select Product Type',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Sticker (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Door Sticker (30x30cm)',
      },
    },
    file: {
      label: 'File',
    },
  },
  buttons: {
    upload: 'Click or Drag to Upload File',
    save: 'Save',
  },
  toasts: {
    changes_got_saved: 'Changes got saved!',
  },
};
